/**
 * Valida CNPJ numérico (legado) e alfanumérico (novo formato Receita Federal).
 *
 * Algoritmo unificado conforme SERPRO: Módulo 11, pesos 2–9 da direita para a esquerda.
 * Valor de cada caractere = charCode - 48
 *   dígitos: '0'→0 … '9'→9
 *   letras:  'A'→17 … 'Z'→42
 */
export function isValidCnpj(document) {
    if (!document) {
        return false;
    }

    const cnpj = document.replace(/[.\/-]/g, '').toUpperCase();

    if (cnpj.length !== 14) {
        return false;
    }

    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) {
        return false;
    }

    if (/^(\d)\1{13}$/.test(cnpj)) {
        return false;
    }

    const raiz = cnpj.substring(0, 12);
    const dv1 = calcDv(raiz);

    if (String(dv1) !== cnpj[12]) {
        return false;
    }

    const dv2 = calcDv(raiz + cnpj[12]);
    return String(dv2) === cnpj[13];
}

function calcDv(chars) {
    let sum = 0;
    let weight = 2;
    for (let i = chars.length - 1; i >= 0; i--) {
        sum += (chars.charCodeAt(i) - 48) * weight;
        weight = weight === 9 ? 2 : weight + 1;
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
}
